import React, { useContext, useState } from "react";
import Carousel from 'react-bootstrap/Carousel';
import { APP_CONSTANTS } from "src/consumer/constants";
import { StyledCarousel, StyledCoursePlay, StyledCarouselNextIcon, StyledCarouselPrevIcon, StyledHeroCard, StyledHeroCardImage, StyledHeroCardContainer, StyledHeroCardContentContainer, StyledHeroCardDesc, StyledHeroCardTitle, StyledHeroCardTransition, StyledPlayButtonContainer } from "./HeroCardsStyle";
import PlayCircleFilledWhiteIcon from '@mui/icons-material/PlayCircleFilledWhite';
import { getCourseCardDetails } from "src/consumer/helpers/courseCardHelper";
import { PlayerContext } from "src/consumer/context/PlayerContext";
import { resetPlayerData } from '../../helpers/playerHelper';

const getCarouselIcon = (buttonType) => {
    return (
        <>
            {buttonType === 'prev' ? <StyledCarouselPrevIcon /> : <StyledCarouselNextIcon />}
        </>
    );
}
export const renderCardsList = (props, setPlayerData, playerData) => {

    const { cardsData, tilePolicyId } = props;

    return cardsData.map((card, index) => {

        const { courseTitle, courseIconImage, courseCategory, courseDescription, courseLongDescription, courseId, courseType, heroCardLandscapeImage, heroCardPortraitImage, coverIconColor, courseSubscriptionId, verticalIconImg } = getCourseCardDetails(card);

        return (
            (heroCardLandscapeImage || heroCardPortraitImage) && <Carousel.Item key={index} onClick={() => {
                setPlayerData({
                    ...resetPlayerData(playerData),
                    showPlayer: true,
                    selectedCard: playerData.showPIP ? playerData?.selectedCard : card,
                    source: 'tile',
                    id: tilePolicyId
                })
            }}>
                <StyledHeroCardContainer>
                    <StyledHeroCard>
                        {/* Optimized image loading for LCP - use actual img tags instead of CSS background */}
                        {heroCardLandscapeImage && (
                            <StyledHeroCardImage
                                src={APP_CONSTANTS.MEDIA_URL + heroCardLandscapeImage}
                                alt={courseTitle || 'Hero card'}
                                data-orientation="landscape"
                                loading={index === 0 ? 'eager' : 'lazy'}
                                fetchPriority={index === 0 ? 'high' : 'auto'}
                                decoding="async"
                            />
                        )}
                        {heroCardPortraitImage && (
                            <StyledHeroCardImage
                                src={APP_CONSTANTS.MEDIA_URL + heroCardPortraitImage}
                                alt={courseTitle || 'Hero card'}
                                data-orientation="portrait"
                                loading={index === 0 ? 'eager' : 'lazy'}
                                fetchPriority={index === 0 ? 'high' : 'auto'}
                                decoding="async"
                            />
                        )}
                        <StyledHeroCardContentContainer>

                            <div>
                                {courseCategory}
                            </div>

                            <StyledHeroCardTitle>
                                {courseTitle}
                            </StyledHeroCardTitle>

                            <StyledHeroCardDesc>
                                {courseDescription}
                            </StyledHeroCardDesc>

                            <StyledPlayButtonContainer>

                                <StyledCoursePlay>
                                    <PlayCircleFilledWhiteIcon />
                                </StyledCoursePlay>

                                <div>Play Now</div>

                            </StyledPlayButtonContainer>

                        </StyledHeroCardContentContainer>
                    </StyledHeroCard>
                    <StyledHeroCardTransition />
                </StyledHeroCardContainer>
            </Carousel.Item>
        );
    })
}

export const HeroCards = (props) => {
    const { playerData, setPlayerData } = useContext(PlayerContext);
    return (
        <>
            <StyledCarousel prevIcon={getCarouselIcon('prev')} nextIcon={getCarouselIcon('next')} interval={!playerData?.showPlayer ? 5000 : null}>
                {renderCardsList(props, setPlayerData, playerData)}
            </StyledCarousel>
        </>
    );
}